import React, { useState } from "react";
import { InlineTextEdit } from "./InlineTextEdit";
import { StoryNode } from "../StoryBook/StoryData";

export const InlineMuliLineSelectStories = [
    new StoryNode(
        () => {
            const [value, setValue] = useState("");
            return (
                <InlineTextEdit
                    text={value}
                    onEdit={(newValue) => {
                        setValue(newValue);
                    }}
                    placeholder="Good Dev"
                    multiLine={true}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Inline Multi Line Text Edit"
    ),
];
